import { Injectable } from '@angular/core';
import { ApiService, ApiCacheOptions } from '../../../shared/index';
import { ISettingService } from './isetting.service';

@Injectable({ providedIn: 'root' })
export class SettingService implements ISettingService {
  public _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;
  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public getSetting = (settingName: string): Promise<string> => {
    //TODO create a route that this can connect to
    return this._apiService.get('Setting/' + settingName, this._cacheOptions).then((data: string) => {
      return Promise.resolve(data);
    });
  };

  public arbEnabled(): Promise<boolean> {
    return this._apiService.get('Settings/ArbEnabled');
  }

  public setArbEnabled(value: boolean): Promise<boolean> {
    return this._apiService.post('Settings/ArbEnabled', value);
  }

  public cardOnFileEnabledEnabled(): Promise<boolean> {
    return this._apiService.get('Settings/CardOnFileEnabled');
  }

  public setCardOnFileEnabled(value: boolean): Promise<boolean> {
    return this._apiService.post('Settings/CardOnFileEnabled', value);
  }
}
